import React, { Ref } from 'react';
import ClassNames from 'classnames';

interface ToolbarButtonProps {
    onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
    isActive?: boolean;
    children?: React.ReactNode;
    borderRight?: boolean;
    borderLeft?: boolean;
    isNarrow?: boolean;
    isLowercase?: boolean;
    isItalic?: boolean;
    isWide?: boolean;
    id?: string;
    style?: React.CSSProperties;
}

const ToolbarButton = React.forwardRef(
    (
        {
            onClick,
            isActive,
            children,
            borderRight,
            borderLeft,
            isNarrow,
            isLowercase,
            isItalic,
            isWide,
            id,
        }: ToolbarButtonProps,
        ref: Ref<HTMLDivElement>
    ) => {
        const buttonClassNames = ClassNames({
            'toolbar-button': true,
            'border-right': borderRight,
            'border-left': borderLeft,
            narrow: isNarrow,
            active: isActive,
            lowercase: isLowercase,
            italic: isItalic,
            wide: isWide,
            [id as string]: true,
        });
        return (
            <div
                className={buttonClassNames}
                onClick={onClick}
                data-cy={id}
                ref={ref}
            >
                {children}
            </div>
        );
    }
);

export default ToolbarButton;
